import { siteData } from "../data/intelligence";

export function SiteHeader() {
  return <header className="site-header"><a href="#overview" className="brand">Airdrop Intelligence</a><nav aria-label="页面导航"><a href="#radar">雷达</a><a href="#archives">档案</a><a href="#alerts">风险</a><a href="#methodology">方法</a></nav><p>静态快照，不自动更新 · 2026-08-01 17:09 · {siteData.meta.timezone}</p></header>;
}
